import { Component, OnInit } from '@angular/core';
import { EnviarEmailService } from '../enviaremail.service'

@Component({
  selector: 'app-fale-conosco',
  templateUrl: './fale-conosco.component.html',
  styleUrls: ['./fale-conosco.component.css']
})
export class FaleConoscoComponent implements OnInit {
  contato = {nome:'', email:'', telefone:'', assunto:'', mensagem:''}
  constructor(private enviaremailService: EnviarEmailService) { }

  ngOnInit() {
  }
  enviarDados(){
  	this.enviaremailService.enviarDados(this.contato).subscribe(data => alert("Enviado"))
  }

}



// WEBPACK FOOTER //
// ./src/app/fale-conosco/fale-conosco.component.ts